<table mat-table [dataSource]="dataSource!" matSort class="mat-elevation-z8">


    <!--     <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
    </ng-container> -->

    <ng-container matColumnDef="projectId">
        <th mat-header-cell *matHeaderCellDef> Projekt Id </th>
        <td mat-cell *matCellDef="let element"> {{element.projectId}} | {{ getProjectName(element.projectId) }} </td>
    </ng-container>
    <ng-container matColumnDef="groupId">
        <th mat-header-cell *matHeaderCellDef> Gruppen Id </th>
        <td mat-cell *matCellDef="let element"> {{element.groupId}} | {{ getGroupName(element.groupId) }} </td>
    </ng-container>
    <ng-container matColumnDef="samId">
        <th mat-header-cell *matHeaderCellDef> SamID </th>
        <td mat-cell *matCellDef="let element"> {{element.samId}} | {{ getDeviceName(element.samId) }} </td>
    </ng-container>
    <ng-container matColumnDef="deKanal">
        <th mat-header-cell *matHeaderCellDef> DeKanal </th>
        <td mat-cell *matCellDef="let element"> {{element.deKanal}} </td>
    </ng-container>
    <ng-container matColumnDef="localBusAdress">
        <th mat-header-cell *matHeaderCellDef> localBusAdress</th>
        <td mat-cell *matCellDef="let element"> {{element.localBusAdress}} </td>
    </ng-container>
    <ng-container matColumnDef="errorType">
        <th mat-header-cell *matHeaderCellDef> Fehlertyp </th>
        <td mat-cell *matCellDef="let element"> {{getErrorTypeString(element.errorType)}} </td>
    </ng-container>
    <ng-container matColumnDef="errorLevel">
        <th mat-header-cell *matHeaderCellDef> Fehlerlevel </th>
        <td mat-cell *matCellDef="let element"> {{ getErrorLevelString(element.errorLevel)}} </td>
    </ng-container>
    <ng-container matColumnDef="describtion">
        <th mat-header-cell *matHeaderCellDef> Beschreibung </th>
        <td mat-cell *matCellDef="let element"> {{element.describtion}} </td>
    </ng-container>
    <ng-container matColumnDef="from">
        <th mat-header-cell *matHeaderCellDef> Von </th>
        <td mat-cell *matCellDef="let element"> {{element.from}} </td>
    </ng-container>
    <ng-container matColumnDef="to">
        <th mat-header-cell *matHeaderCellDef> Bis </th>
        <td mat-cell *matCellDef="let element"> {{element.to}} </td>
    </ng-container>
    <ng-container matColumnDef="errorSolved">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element">
            <span *ngIf="element.errorSolved"><img src="assets/icons/check_circle_material.svg" height="24"></span>
            <span *ngIf="!element.errorSolved"><img src="assets/icons/cancel_material.svg" height="24"></span>

        </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>